import React from 'react'
import { BarChart3 } from 'lucide-react'

const formatPrice = (value) => {
  if (!Number.isFinite(Number(value))) return '—'
  if (Math.abs(Number(value)) >= 1_000_000) {
    return `${(Number(value) / 1_000_000).toLocaleString('cs-CZ', { maximumFractionDigits: 2 })} mil. Kč`
  }
  return `${Math.round(Number(value)).toLocaleString('cs-CZ')} Kč`
}

const SocialVisual = React.forwardRef(({ post, compact = false }, ref) => {
  const listing = post.evidence?.listing
  const market = post.evidence?.market
  const imageUrl = post.draft?.imageUrl || listing?.imageUrl

  return (
    <div
      ref={ref}
      className={`relative isolate aspect-[4/5] w-full overflow-hidden rounded-2xl bg-slate-950 text-white shadow-sm ${compact ? 'max-w-[260px]' : 'max-w-[430px]'}`}
      style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          className="!float-none absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(190,242,100,0.34),transparent_35%),radial-gradient(circle_at_80%_70%,rgba(139,92,246,0.5),transparent_44%),linear-gradient(145deg,#0f172a,#3b0764)]">
          <div className="absolute left-[12%] top-[22%] h-[36%] w-[10%] rounded-t-xl bg-white/10" />
          <div className="absolute left-[26%] top-[36%] h-[22%] w-[10%] rounded-t-xl bg-lime-300/50" />
          <div className="absolute left-[40%] top-[17%] h-[41%] w-[10%] rounded-t-xl bg-white/20" />
          <div className="absolute left-[54%] top-[29%] h-[29%] w-[10%] rounded-t-xl bg-violet-300/40" />
          <div className="absolute left-[68%] top-[10%] h-[48%] w-[10%] rounded-t-xl bg-lime-300/70" />
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/55 via-slate-950/5 to-slate-950/95" />

      <div className={`absolute inset-0 flex flex-col justify-between ${compact ? 'p-4' : 'p-7'}`}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 font-semibold tracking-tight">
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-lime-300 text-sm font-black text-slate-950">J</span>
            <span className={compact ? 'text-xs' : 'text-sm'}>Realitní Jestřáb</span>
          </div>
          <span className="rounded-full border border-white/25 bg-slate-950/30 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] backdrop-blur-sm">
            {post.category === 'market_pulse' ? 'Trh v číslech' : post.category === 'luxury' ? 'Nabídka dne' : 'Příležitost'}
          </span>
        </div>

        <div>
          {market && (
            <div className="mb-3 flex items-center gap-2 text-lime-300">
              <BarChart3 className={compact ? 'h-4 w-4' : 'h-6 w-6'} />
              <span className="text-xs font-semibold uppercase tracking-[0.18em]">{market.region}</span>
            </div>
          )}
          <h2 className={`max-w-[94%] font-black leading-[1.03] tracking-[-0.035em] drop-shadow-lg ${compact ? 'text-2xl' : 'text-4xl'}`}>
            {post.draft?.headline}
          </h2>
          <div className={`mt-4 flex flex-wrap gap-x-3 gap-y-1 text-white/80 ${compact ? 'text-[10px]' : 'text-xs'}`}>
            {listing && <span>{listing.location || listing.title}</span>}
            {listing?.m2 && <span>{Number(listing.m2).toLocaleString('cs-CZ')} m²</span>}
            {listing?.m2Price && <span>{formatPrice(listing.m2Price)}/m²</span>}
            {market?.activeListingCount !== null && market?.activeListingCount !== undefined && (
              <span>{Number(market.activeListingCount).toLocaleString('cs-CZ')} aktivních nabídek</span>
            )}
          </div>
          <div className={`mt-4 border-t border-white/20 pt-3 text-white/60 ${compact ? 'text-[8px]' : 'text-[10px]'}`}>
            Nabídková data a orientační odhady · realitni-jestrab.cz
          </div>
        </div>
      </div>
    </div>
  )
})

SocialVisual.displayName = 'SocialVisual'

export default SocialVisual
